import type { ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";
import type { IDropDownItem } from "@similarweb/ui-components";
import { Checkbox } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { ConditionalTooltipText } from "app/pages/sales-intelligence/common-components/ConditionalTooltipText";
import {
    StyledFormCheckboxDropdownItem,
    StyledFormDropdownItemTextWrapper,
    StyledFormDropdownItemTitleWrapper,
} from "app/pages/sales-intelligence/common-components/form-fields/components/FormCheckboxDropdownItem/styles";

interface IProps extends IDropDownItem {
    id: string;
    title: string;
    subtitle?: string;
    renderTag?: (id: string) => ReactElement | null;
}

export const FormCheckboxDropdownItem = ({ title, subtitle, renderTag, ...props }: IProps): ReactElement => {
    const label = (
        <StyledFormDropdownItemTextWrapper>
            <Flex
                gap="8px"
                alignItems="center"
            >
                <StyledFormDropdownItemTitleWrapper>
                    <ConditionalTooltipText
                        fontVariant="input2"
                        color={colorsPalettes.carbon[500]}
                        data-automation="form-dropdown-item-title"
                    >
                        {title}
                    </ConditionalTooltipText>
                </StyledFormDropdownItemTitleWrapper>
                {renderTag ? renderTag(props.id) : null}
            </Flex>
            {subtitle ? (
                <ConditionalTooltipText
                    fontVariant="listItem3"
                    color={colorsPalettes.carbon[300]}
                    data-automation="form-dropdown-item-subtitle"
                >
                    {subtitle}
                </ConditionalTooltipText>
            ) : null}
        </StyledFormDropdownItemTextWrapper>
    );

    return (
        <StyledFormCheckboxDropdownItem {...props}>
            <Checkbox
                label={label}
                onClick={() => null}
                selected={props.selected}
            />
        </StyledFormCheckboxDropdownItem>
    );
};
